export default __webpack_public_path__ + "static/media/WebsRobots.dbbe9303.jpg";